import React from "react";

function PastCallIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 96 96"
    >
      <path
        fill="#fff"
        d="M46.568 70.296c.387.097.801-.022 1.083-.305l8.581-8.581c1.343-1.343 22.167 13.509 18.724 16.952l-8.342 8.342c-3.447 3.447-25.077.494-40.239-14.668-14.39-14.39-17.966-36.642-14.519-40.089l8.342-8.342c3.443-3.443 19.045 17.461 17.665 18.841l-9.274 9.274a1.143 1.143 0 00-.282 1.15c.899 2.879 5.196 14.144 18.261 17.426z"
        data-original="#4a95d0"
      ></path>
      <path
        fill="#f4912e"
        d="M74.353 65.512a3.017 3.017 0 01-2.133-5.15c4.584-4.584 7.109-10.681 7.109-17.165s-2.525-12.58-7.109-17.165c-8.476-8.476-22.095-9.465-31.678-2.3A3.016 3.016 0 1136.93 18.9c11.969-8.948 28.974-7.715 39.556 2.867 5.724 5.723 8.876 13.334 8.876 21.43s-3.152 15.707-8.876 21.431a3.008 3.008 0 01-2.133.884z"
        data-original="#f4912e"
      ></path>
      <path
        fill="#c16b2b"
        d="M67.299 46.841h-11.24a4.097 4.097 0 01-4.093-4.093V31.607a2.742 2.742 0 115.484 0v9.75h9.848a2.742 2.742 0 01.001 5.484z"
        data-original="#c16b2b"
      ></path>
      <path
        fill="#f4912e"
        d="M48.95 28.314c-.309 0-.623-.048-.932-.148l-10.943-3.553c-.912-.283-1.585-.822-1.986-1.595l-.58-1.119.387-1.224 3.438-10.588a3.018 3.018 0 015.739 1.863l-2.524 7.773 8.333 2.705a3.017 3.017 0 01-.932 5.886z"
        data-original="#f4912e"
      ></path>
    </svg>
  );
}

export default PastCallIcon;